__turbopack_context__.v({
  "form": "enter-code-module-scss-module__UZSGta__form",
  "input": "enter-code-module-scss-module__UZSGta__input",
  "resend": "enter-code-module-scss-module__UZSGta__resend",
});
